import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: null,
        tokenExpire: null,
        tagsStoreList: [],
        language: Cookies.get('language') || 'en',
        isSignIn: false, // 是否登录
        isSignIn1Data: JSON.parse(localStorage.getItem('isSignIn1Data')) || 'admin',
        talentName: JSON.parse(localStorage.getItem('tenancyName')),
        waitAuditCount: 0,
        afterSaleOrderNumber: 0,
        accountManagerAfterSaleOrderNumber: 0,
        isShowOA: false,
        isShowFaceVersion: false,
        isShowAfterSales: false,
        tenantId: null, // 租户Id
        tenancyName: JSON.parse(localStorage.getItem('tenancyName')),
        toConfirmGoodSource: { num: 0, result: false }, // 待确认货源
        over72Hours: { num: 0, result: false }, // 超72小时未反馈物流
        overConfirmGoodSource: { num: 0, result: false }, // 超时确认货源
        toDelivery: { num: 0, result: false }, // 待发货
        aftersales: { num: 0, result: false }, // 售后订单
        repairOrder: { num: 0, result: false }, // 报装订单
    },
    mutations: {
        saveTenantId(state, data) {
            state.tenantId = data;
            window.localStorage.setItem("Abp.TenantId", data);
        },
        saveToken(state, data) {
            state.token = data;
            window.localStorage.setItem("Token", data);
        },
        saveTokenExpire(state, data) {
            state.tokenExpire = data;
            window.localStorage.setItem("TokenExpire", data);
        },
        saveTagsData(state, data) {
            state.tagsStoreList = data;
            sessionStorage.setItem("Tags", data)
        },
        SET_LANGUAGE: (state, language) => {
            state.language = language
            Cookies.set('language', language)
        },
        setIsSignIn(state, data) {
            state.isSignIn = data
            // console.log('state.isSignIn ', state.isSignIn );
            sessionStorage.setItem("isSignIn", data);
        },
        setIsSignIn1(state, data) {
            state.isSignIn1Data = data.surname;
            // console.log('state.isSignIn1Data',  data );
            localStorage.setItem("isSignIn1Data", JSON.stringify(data.surname));
        },
        setTalentName(state, data) {
            // console.log('0000000000000000',data)
            state.tenancyName = data.name
            // console.log('租户名称',  data );
            localStorage.setItem("tenancyName", JSON.stringify(data.name));
        },
        setWaitAuditCount(state, data) {
            state.waitAuditCount = data
        },
        setAfterSaleOrderNumber(state, data) {
            state.afterSaleOrderNumber = data
        },
        setAccountManagerAfterSaleOrderNumber(state, data) {
            state.accountManagerAfterSaleOrderNumber = data
        },
        setIsShowOA(state, data) {
            state.isShowOA = data
        },
        setIsShowFaceVersion(state, data) {
            state.isShowFaceVersion = data
        },
        setIsShowAfterSales(state, data) {
            state.isShowAfterSales = data
        },
        // toConfirmGoodSource
        setToConfirmGoodSource(state, data) {
            state.toConfirmGoodSource = { num: data, result: true }
        },
        // over72Hours
        setOver72Hours(state, data) {
            state.over72Hours = { num: data, result: true }
        },
        // overConfirmGoodSource
        setOverConfirmGoodSource(state, data) {
            state.overConfirmGoodSource = { num: data, result: true }
        },
        // toDelivery
        setToDelivery(state, data) {
            state.toDelivery = { num: data, result: true }
        },
        // aftersales
        setAftersales(state, data) {
            state.aftersales = { num: data, result: true }
        },
        // aftersales
        setRepairOrder(state, data) {
            state.repairOrder = { num: data, result: true }
        },
    },
    actions: {
        setLanguage({ commit }, language) {
            commit('SET_LANGUAGE', language)
        },
    }
})
